// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__AzgdP","faq-cards":"Faq_faq-cards__N+nt7","dark":"Faq_dark__Q7RQE"};